import BugBounty from 'components/Content/BugBounty/BugBounty';

export default BugBounty;
